<template>
  <ion-page>
    <div v-if="isStaging" class="odn-staging-bar"></div>
    <ion-tabs>
      <ion-router-outlet></ion-router-outlet>
      <ion-tab-bar slot="bottom">
        <ion-tab-button tab="stores" :disabled="!tabs" href="/tabs/stores">
          <ion-icon :icon="icons.storefrontOutline"></ion-icon>
        </ion-tab-button>

        <ion-tab-button
          v-if="hasFeatProjects"
          tab="projects"
          :disabled="!tabs"
          href="/tabs/projects"
        >
          <ion-icon :icon="icons.fileTrayOutline"></ion-icon>
        </ion-tab-button>

        <ion-tab-button
          v-if="hasFeatAppointments"
          tab="appointments"
          :disabled="!tabs"
          href="/tabs/appointments/list"
        >
          <ion-icon :icon="icons.calendarOutline"></ion-icon>
        </ion-tab-button>

        <ion-tab-button
          v-if="hasFeatProductScan"
          tab="products"
          :disabled="!tabs"
          href="/tabs/products/scan"
        >
          <ion-icon :icon="icons.barcodeOutline"></ion-icon>
        </ion-tab-button>

        <ion-tab-button tab="procedures" :disabled="!tabs" href="/tabs/help">
          <ion-icon :icon="icons.helpBuoyOutline"></ion-icon>
        </ion-tab-button>

        <ion-tab-button tab="profile" :disabled="!tabs" href="/tabs/profile">
          <ion-icon :icon="icons.personOutline"></ion-icon>
          <ion-badge v-if="notificationCount > 0" color="danger">
            {{ notificationCount }}
          </ion-badge>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import {
  IonRouterOutlet,
  IonIcon,
  IonPage,
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonBadge,
} from '@ionic/vue';
import {
  storefrontOutline,
  fileTrayOutline,
  calendarOutline,
  helpBuoyOutline,
  personOutline,
  barcodeOutline,
} from 'ionicons/icons';

export default {
  name: 'Tabs',
  components: {
    IonRouterOutlet,
    IonIcon,
    IonPage,
    IonTabBar,
    IonTabButton,
    IonTabs,
    IonBadge,
  },
  data() {
    return {
      refreshInterval: 60000,
      refreshHandler: null,
      icons: {
        storefrontOutline,
        fileTrayOutline,
        calendarOutline,
        helpBuoyOutline,
        personOutline,
        barcodeOutline,
      },
    };
  },
  computed: {
    ...mapState('auth', ['loggedIn', 'authData']),
    ...mapState('notifications', ['notificationCount']),
    ...mapState('prefs', ['tabs']),
    hasFeatProjects() {
      return (
        process.env.VUE_APP_FEAT_PROJECTS &&
        process.env.VUE_APP_FEAT_PROJECTS == 'true' &&
        this.$isAllowedModuleAction('PROJECTS', 'READ')
      );
    },
    hasFeatProductScan() {
      return (
        process.env.VUE_APP_FEAT_PRODUCT_SCAN &&
        process.env.VUE_APP_FEAT_PRODUCT_SCAN == 'true'
      );
    },
    hasFeatAppointments() {
      return this.$isAllowedModuleAction('APPOINTMENTS', 'READ');
    },
    isStaging() {
      return (
        process.env.VUE_APP_IS_STAGING &&
        process.env.VUE_APP_IS_STAGING == 'true'
      );
    },
  },
  ionViewDidEnter() {
    this.fetchNotifications();

    this.refreshHandler = setInterval(
      this.fetchNotifications,
      this.refreshInterval
    );
  },
  ionViewDidLeave() {
    clearInterval(this.refreshHandler);
  },
  methods: {
    ...mapActions('notifications', ['fetchNotifications']),
  },
};
</script>
